import axios from 'axios';
import { useClientId } from "../context/context.js";


const apiBaseUrl = process.env.REACT_APP_API_URL;

export function useBookingData() {
  const clientId = useClientId();

  const getBookingById = async (id) => {
    const { data } = await axios.get(`${apiBaseUrl}/clients/${clientId}/bookings/${id}`);
    return data;
  }

  const getFullBooking = async (id) => {
    const { data } = await axios.get(`${apiBaseUrl}/clients/${clientId}/bookings/${id}/get-full`);
    return data;
  }

  const fetchContractsBlob = async (bookingId) => {
    const response = await axios.get(`${apiBaseUrl}/clients/${clientId}/bookings/generate-contract?bookingId=${bookingId}`, {
      responseType: 'blob',
    });
    
    const blob = new Blob([response.data], { type: 'application/pdf' });
    return blob;
  };

  const contractsUrl = (bookingId) => `${apiBaseUrl}/clients/${clientId}/bookings/generate-contract?bookingId=${bookingId}`;
      
  return {
    getBookingById,
    getFullBooking,
    fetchContractsBlob,
    contractsUrl,
  };
}
